import config from '../config/config'

/**
 * Auth route names that have WorkOS-specific implementations
 */
type WorkOSAuthRoute =
  | 'sign-in'
  | 'check-session'
  | 'sign-out'
  | 'reset-password'
  | 'confirm-reset-password'
  | 'accept-invitation'
  | 'magic-auth/send-code'
  | 'magic-auth/verify-code'

type AuthRoute = WorkOSAuthRoute

/**
 * Generates the correct auth API route based on the authProvider config.
 *
 * @param route - The auth route name (e.g., 'sign-in', 'accept-invitation')
 * @returns The full API URL path
 *
 * @example
 * // When config.authProvider = 'firebase'
 * getAuthRoute('sign-in') // '/api/v1/unauthenticated/auth/sign-in'
 *
 * // When config.authProvider = 'workos'
 * getAuthRoute('sign-in') // '/api/v1/unauthenticated/auth/workos/sign-in'
 */
export const getAuthRoute = (route: AuthRoute): string => {
  const baseUrl = `${config.apiUrl}/unauthenticated/auth`

  // WorkOS routes get the /workos segment
  if (config.authProvider === 'workos') {
    return `${baseUrl}/workos/${route}`
  }

  // Firebase routes (default)
  return `${baseUrl}/${route}`
}
